import React from 'react'
import { Savings } from 'src/components/Savings/Savings'
import SEO from 'src/seo'
const SavingsPage = () => {
  return (
    <div>
      <SEO title="Savings" />
      <Savings />
    </div>
  )
}
export { SavingsPage }
